export default "__VITE_ASSET__BTk2lmUB__"